<template>
  <div class="property-details-media-map-ui">
    <VMap
      v-if="gmapApiKey"
      :options="options"
      :place="place"
      :disable-map-if-no-coordinates-found="false"
      :show-full-screen-control="false"
      :show-types-control="false"
    >
      <template #zoomControls="{ disabled, zoomIn, zoomOut }">
        <PropertyDetailsMediaZoomControls
          :disabled="disabled"
          @zoom-in="zoomIn"
          @zoom-out="zoomOut"
        />
      </template>
    </VMap>
    <OpportunityErrorScreen v-else title="Invalid Google Maps API key. Please contact support." />
  </div>
</template>

<script setup lang="ts">
  // Types
  import type { RuntimeConfig } from 'nuxt/schema';
  import type { IMapPlace, TMapOptions } from '~/misc/v-map/types';
  import { EGoogleMapTypeId } from '~/misc/v-map/types';

  // Config
  import { INITIAL_ZOOM_FACTOR } from '~/misc/opportunity/property-details/media/map/config';

  // Components
  import OpportunityErrorScreen from '~/misc/opportunity/error-screen/OpportunityErrorScreen.vue';
  import VMap from '~/misc/v-map';
  import PropertyDetailsMediaZoomControls from '~/misc/opportunity/property-details/media/zoom-controls/PropertyDetailsMediaZoomControls.vue';

  const props = defineProps<{
    gmapApiKey: string | undefined;
    lat: number;
    lon: number;
  }>();

  const config: RuntimeConfig = useRuntimeConfig();

  const options: ComputedRef<TMapOptions> = computed<TMapOptions>(() => ({
    mapTypeId: EGoogleMapTypeId.ROADMAP,
    center: {
      lat: props.lat,
      lng: props.lon,
    },
    disableDefaultUI: true,
    scrollwheel: true,
    zoom: INITIAL_ZOOM_FACTOR,
    mapId: config.public.GMAP_API_MAP_ID,
  }));

  const place: ComputedRef<IMapPlace> = computed<IMapPlace>(() => ({
    lat: props.lat,
    lng: props.lon,
    iconColor: '#000',
  }));
</script>
